import { render, staticRenderFns } from "./ClaimCategory.vue?vue&type=template&id=c53157f0"
import script from "./ClaimCategory.vue?vue&type=script&lang=js"
export * from "./ClaimCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports